/**
 * Flatten a per-bank lift-name map (`{ [bankId]: { [liftId]: name } }`) into a
 * single flat `{ [liftId]: name }` lookup. `ScheduledActionList` renders lift
 * names without caring which bank owns a lift, so the wizard collapses its
 * nested map to feed the list. On the (practically impossible) event of a
 * duplicate lift id across banks, the later bank wins.
 */
export default function flattenLiftNames(
  liftNamesByBank: Record<string, Record<string, string>>,
): Record<string, string> {
  const out: Record<string, string> = {};
  Object.values(liftNamesByBank).forEach((nameMap) => {
    Object.entries(nameMap).forEach(([id, name]) => {
      out[id] = name;
    });
  });
  return out;
}
